import { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

/**
 * Landing spot for the Keycloak SSO round trip: the backend's
 * GET /api/auth/callback redirects here with `?token=<app jwt>` once
 * Keycloak login succeeds (or with an error, handled by redirecting
 * straight to /login?error=... instead — see hcasp/views.py sso_callback).
 */
const AuthCallback = () => {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const { completeSSOLogin } = useAuth();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;

    const token = params.get("token");
    if (!token) {
      navigate("/login?error=sso_failed", { replace: true });
      return;
    }

    (async () => {
      const user = await completeSSOLogin(token);
      if (user) {
        toast.success("Welcome back!");
        navigate("/user-panel", { replace: true });
      } else {
        navigate("/login?error=sso_failed", { replace: true });
      }
    })();
  }, [params, completeSSOLogin, navigate]);

  return (
    <div className="min-h-screen bg-[#07070c] flex items-center justify-center">
      <Loader2 className="animate-spin text-[#16fcfb]" size={32} />
    </div>
  );
};

export default AuthCallback;
